import {
    useDeleteSavedSearchMutation,
    useSaveSearchByPlaceMutation,
    useUpdateSearchByPlaceMutation,
} from 'src/hooks/__generated__/queries';
import type {
    SaveSearchByPlaceMutationVariables,
    UpdateSearchByPlaceMutationVariables,
} from 'src/types/__generated__/graphql';
import { SearchAdsCountSinceLastViewed } from 'src/types/__generated__/graphql';

export const useSavedSearchMutations = () => {
    const [saveSearchByPlaceMutation] = useSaveSearchByPlaceMutation();
    const [updateSearchByPlaceMutation] = useUpdateSearchByPlaceMutation();
    const [deleteSavedSearchMutation] = useDeleteSavedSearchMutation();

    const saveSavedSearch = async (params: SaveSearchByPlaceMutationVariables) => {
        const { data } = await saveSearchByPlaceMutation({
            variables: params,
            refetchQueries: ['SavedSearches', 'CurrentUser'],
            awaitRefetchQueries: true,
        });
        return data?.saveSearchByPlace;
    };

    const updateSavedSearch = async (params: UpdateSearchByPlaceMutationVariables) => {
        const { data } = await updateSearchByPlaceMutation({
            variables: params,
            refetchQueries: ['SavedSearches', 'Search', 'CurrentUser'],
            awaitRefetchQueries: true,
        });
        return data?.updateSearchByPlace;
    };

    const updateSavedSearchLastViewedAt = async ({ id, lastViewedAt }: { id: string; lastViewedAt: Date }) => {
        await updateSearchByPlaceMutation({
            variables: {
                id,
                lastViewedAt,
            },
            // we refetch the count only for the total and the search we cliked on
            refetchQueries: [
                {
                    query: SearchAdsCountSinceLastViewed,
                    variables: {
                        id,
                    },
                },
                {
                    query: SearchAdsCountSinceLastViewed,
                    variables: undefined,
                },
            ],
        });
    };

    const deleteSavedSearch = async (id: string) => {
        await deleteSavedSearchMutation({
            variables: {
                searchId: id,
            },
            refetchQueries: ['SavedSearches'],
            awaitRefetchQueries: true,
        });
    };

    return {
        deleteSavedSearch,
        updateSavedSearchLastViewedAt,
        updateSavedSearch,
        saveSavedSearch,
    };
};
